module.exports = __webpack_public_path__ + "media/src/assets/img/portrait/small/avatar-s-6-0c96c10d8849f0377363d152f6726da2.jpg";